export { StudentLoansBanner } from './StudentLoansBanner';
export type {
  StudentLoansBannerCta,
  StudentLoansBannerDataPoint,
  StudentLoansBannerLayout,
  StudentLoansBannerLearnMore,
  StudentLoansBannerPartner,
  StudentLoansBannerProps,
} from './types';
